import React from 'react';
import PropTypes from 'prop-types';

import './loader.scss';

const LoaderView = (props) => {
  const styles = {
    width: `${props.loaderWidth}%`,
    opacity: props.isLoading ? 1 : 0,
  };

  return (
    <div className={'m-loader'} style={styles} />
  );
};

LoaderView.propTypes = {
  loaderWidth: PropTypes.number,
  isLoading: PropTypes.bool,
};

LoaderView.defaultProps = {
  loaderWidth: 0,
  isLoading: false,
};

export default LoaderView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Loader/LoaderView.jsx